
__webpack_require__.S = {};
__webpack_require__.initializeSharingData = { scopeToSharingDataMapping: { "default": [{ name: "@nackle/biw-web-router", version: "2.0.7", factory: () => (Promise.all([__webpack_require__.e("694"), __webpack_require__.e("69")]).then(() => (() => (__webpack_require__(46133))))), eager: 0 }, { name: "@nackle/bridge", version: "3.0.50", factory: () => (Promise.all([__webpack_require__.e("467"), __webpack_require__.e("532")]).then(() => (() => (__webpack_require__(97638))))), eager: 0 }, { name: "@nackle/intl-tools", version: "1.4.85", factory: () => (__webpack_require__.e("582").then(() => (() => (__webpack_require__(45253))))), eager: 0 }, { name: "@nackle/studio-tools", version: "1.9.144", factory: () => (Promise.all([__webpack_require__.e("600"), __webpack_require__.e("299"), __webpack_require__.e("200"), __webpack_require__.e("682"), __webpack_require__.e("384")]).then(() => (() => (__webpack_require__(5483))))), eager: 0 }, { name: "@nackle/umbrella-studio", version: "1.5.42", factory: () => (__webpack_require__.e("171").then(() => (() => (__webpack_require__(76214))))), eager: 0 }, { name: "@nackle/umbrella", version: "2.1.35", factory: () => (Promise.all([__webpack_require__.e("906"), __webpack_require__.e("242")]).then(() => (() => (__webpack_require__(9545))))), eager: 0 }, { name: "antd", version: "5.29.3", factory: () => (Promise.all([__webpack_require__.e("600"), __webpack_require__.e("299"), __webpack_require__.e("858"), __webpack_require__.e("390"), __webpack_require__.e("59")]).then(() => (() => (__webpack_require__(6425))))), eager: 0 }, { name: "dayjs", version: "1.11.23", factory: () => (() => (__webpack_require__(9182))), eager: 1 }, { name: "react-dom", version: "18.3.1", factory: () => (() => (__webpack_require__(8143))), eager: 1 }, { name: "react-redux", version: "9.3.0", factory: () => (__webpack_require__.e("569").then(() => (() => (__webpack_require__(52536))))), eager: 0 }, { name: "react", version: "18.3.1", factory: () => (() => (__webpack_require__(30758))), eager: 1 }, { name: "redux", version: "5.0.1", factory: () => (__webpack_require__.e("811").then(() => (() => (__webpack_require__(18398))))), eager: 0 }] }, uniqueName: "@nackle/umbrella-studio-webapp" };
var initPromises = {};
var initTokens = {};
__webpack_require__.I = function(name, initScope) {
	if (!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if (!initToken) initToken = initTokens[name] = {};
	if (initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if (initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if (!__webpack_require__.o(__webpack_require__.S, name))
		__webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = function (msg) {
		if (typeof console !== "undefined" && console.warn) console.warn(msg);
	};
	var uniqueName = __webpack_require__.initializeSharingData.uniqueName;
	var register = function (name, version, factory, eager) {
		var versions = (scope[name] = scope[name] || {});
		var activeVersion = versions[version];
		if (
			!activeVersion ||
			(!activeVersion.loaded &&
				(!eager != !activeVersion.eager
					? eager
					: uniqueName > activeVersion.from))
		)
			versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = function (id) {
		var handleError = function (err) {
			warn("Initialization of sharing external failed: " + err);
		};
		try {
			var module = __webpack_require__(id);
			if (!module) return;
			var initFn = function (module) {
				return (
					module &&
					module.init &&
					module.init(__webpack_require__.S[name], initScope)
				);
			};
			if (module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if (initResult && initResult.then)
				return promises.push(initResult["catch"](handleError));
		} catch (err) {
			handleError(err);
		}
	};
	var promises = [];
	var scopeToSharingDataMapping = __webpack_require__.initializeSharingData.scopeToSharingDataMapping;
	if (scopeToSharingDataMapping[name]) {
		scopeToSharingDataMapping[name].forEach(function (stage) {
			if (typeof stage === "object") register(stage.name, stage.version, stage.factory, stage.eager);
			else initExternal(stage)
		});
	}
	if (!promises.length) return (initPromises[name] = 1);
	return (initPromises[name] = Promise.all(promises).then(function () {
		return (initPromises[name] = 1);
	}));
};

